import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeviceComponent } from './device.component';
import { DeviceRoutingModule } from './device-routing.module';
import { FormsModule} from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import {TableModule} from 'primeng/table';
import {InputTextModule} from 'primeng/inputtext';
import {ToastModule} from 'primeng/toast';
import {ButtonModule} from 'primeng/button';

@NgModule({
  imports: [
    CommonModule,
    DeviceRoutingModule,
    FormsModule,
    TranslateModule,
    TableModule,
    InputTextModule,
    ToastModule,
    ButtonModule
  ],
  declarations: [DeviceComponent]
})
export class DeviceModule { }
